import { render, staticRenderFns } from "./m-scratch.vue?vue&type=template&id=5d88c4d9&scoped=true&"
import script from "./m-scratch.vue?vue&type=script&lang=js&"
export * from "./m-scratch.vue?vue&type=script&lang=js&"
import style0 from "./m-scratch.vue?vue&type=style&index=0&id=5d88c4d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d88c4d9",
  null
  
)

export default component.exports